module.exports = __webpack_public_path__ + "static/media/WhiteClose.1e488fb2.svg";